/**
 * Header component displaying PSM logo and user welcome message.
 * Shows logout link when user is authenticated.
 * Includes theme toggle for light/dark mode.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import NotificationBell from './NotificationBell';

/**
 * Header component.
 * @returns {JSX.Element} Header with logo, theme toggle, and welcome message
 */
function Header() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
  };

  const handleLogoClick = () => {
    if (user) {
      navigate('/dashboard');
    }
  };

  return (
    <>
      <div className="logo-container">
        <div className="logo-wrapper" onClick={handleLogoClick}>
          <img src="/logo.png" alt="Hanwha Power" className="logo-img" />
        </div>

        {user && (
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            aria-label="Toggle theme"
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        )}
      </div>

      {user && (
        <div className="welcome-bar">
          <span className="welcome-text">
            Welcome,{' '}
            <span onClick={() => navigate('/account')} style={{ cursor: 'pointer', color: 'var(--orange-primary)', fontWeight: 600 }}>
              {user.name}
            </span>
            {user.role && user.role !== 'user' && (
              <span className={`role-badge role-badge-${user.role}`}>
                {user.role === 'super_admin' ? 'SUPER ADMIN' : user.role === 'admin' ? 'ADMIN' : user.role.toUpperCase()}
              </span>
            )}
            {' '}| <span onClick={handleLogout} style={{ cursor: 'pointer', color: 'var(--orange-primary)', fontWeight: 600 }}>Logoff</span>
          </span>
          <NotificationBell />
        </div>
      )}
    </>
  );
}

export default Header;
